import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import WhyNow from "@/components/landing/WhyNow";
import Approach from "@/components/landing/Approach";
import DataHandling from "@/components/landing/DataHandling";
import Engagement from "@/components/landing/Engagement";
import Anumati from "@/components/landing/Anumati";
import WhyDhwani from "@/components/landing/WhyDhwani";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import ContactFab from "@/components/landing/ContactFab";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white text-[#0B0B0F]">
      <Header />
      <main>
        <Hero />
        <WhyNow />
        <Approach />
        <DataHandling />
        <Engagement />
        <Anumati />
        <WhyDhwani />
        <ContactSection />
      </main>
      <Footer />
      <ContactFab />
    </div>
  );
}
